import React from 'react';
import styles from './styles.module.scss';
import AGTech from '../../assets/casestudy/KumarPhotoGraphy.webp'
import GenuineItSystem from '../../assets/casestudy/Genuine IT Systems.webp'
import wifi from '../../assets/img/wifiicon.png'
import case_studies from '../../assets/img/case_studiesicon.png'
import { Link, useNavigate } from "react-router-dom";
interface CaseStudyProps {
  title: string;
  header:string;
  subtitle: string;
  industry: string;

  description: React.ReactNode;
  objective: {
    heading: string;
    content: React.ReactNode;
  };
  process: {
    heading: string;
    content: React.ReactNode;
  };
  impact: {
    heading: string;
    content: React.ReactNode;
  };
   conclusion: {
    heading: string;
    content: React.ReactNode;
  };
  heroImage: string;
  projectImage: string;
  projectImage2: string;
    projectImage3: string;
  technologies: { name: string; icon: string }[];
  timescale: string;
  launchDate: string;
  websiteUrl?: string;
    caseStudies: {
    image: string;
    title: string;
    category: string;
    pagelink:string;
    link: string;
  }[];
    services:{
      label:string;
  link: string;

    } [];
  
}



const CaseStudy: React.FC<CaseStudyProps> = ({
  title,
  header,
  subtitle,
  industry,
  services,
  description,
  objective,
  process,
  impact,
  conclusion,
  heroImage,
  projectImage,
  projectImage2,
  projectImage3,
  technologies,
  timescale,
  launchDate,
  websiteUrl,
  caseStudies,
  
  
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.heroSection}>
        <img src={heroImage} alt={`${title} banner`} className={styles.heroImage} />
        
        <div className={styles.overlay}>
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
        
        <div className={styles.overlay1}>
          <div className={styles.industry}>Industry</div>
          <p className={styles.industry1}>{industry}</p>
        </div>
      </div>
<div className='container'>
      <div className={styles.detailsSection}>
        <div className={styles.leftColumn}>
          <h3 className={styles.servicetitle}>Services Provided</h3>
         <div className={styles.tags}>
  {services.map((service, index) => (
    <Link key={index} to={service.link} className={styles.tag}>
      {service.label}
    </Link>
  ))}
</div>
        </div>

        <div className={styles.rightColumn}>
          <h2>{title}</h2>
          <p className={styles.header}>{header}</p>
          <p className={styles.description}>{description}</p>

          <ul className={styles.infoList}>
            <li className={styles.infoItem}>
              <div className={styles.infoLeft}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.675 14.6648L20.1398 13.3523C20.2125 12.907 20.25 12.4523 20.25 11.9976C20.25 11.5429 20.2125 11.0883 20.1398 10.6429L21.675 9.33044C21.7908 9.23132 21.8737 9.09929 21.9126 8.95193C21.9515 8.80456 21.9447 8.64883 21.893 8.50544L21.8719 8.44451C21.4492 7.26332 20.8164 6.16834 20.0039 5.21248L19.9617 5.16326C19.8631 5.04736 19.7318 4.96405 19.5849 4.92431C19.4381 4.88456 19.2826 4.89024 19.1391 4.9406L17.2336 5.61794C16.5305 5.04138 15.7453 4.58669 14.8969 4.26794L14.5289 2.27576C14.5011 2.12586 14.4284 1.98795 14.3204 1.88036C14.2124 1.77277 14.0742 1.70059 13.9242 1.67341L13.8609 1.66169C12.6398 1.44138 11.3555 1.44138 10.1344 1.66169L10.0711 1.67341C9.92108 1.70059 9.78289 1.77277 9.67488 1.88036C9.56688 1.98795 9.49416 2.12586 9.4664 2.27576L9.09609 4.27732C8.25442 4.59614 7.47062 5.05058 6.77577 5.62263L4.85624 4.9406C4.71272 4.88984 4.55716 4.88395 4.41022 4.92372C4.26327 4.9635 4.13191 5.04704 4.03359 5.16326L3.9914 5.21248C3.17987 6.16902 2.54712 7.26381 2.12343 8.44451L2.10234 8.50544C1.99687 8.79841 2.08359 9.12654 2.32031 9.33044L3.87421 10.657C3.80156 11.0976 3.7664 11.5476 3.7664 11.9953C3.7664 12.4453 3.80156 12.8953 3.87421 13.3336L2.32031 14.6601C2.20451 14.7593 2.12164 14.8913 2.0827 15.0387C2.04377 15.186 2.05062 15.3418 2.10234 15.4851L2.12343 15.5461C2.54765 16.7273 3.17577 17.8172 3.9914 18.7781L4.03359 18.8273C4.13215 18.9432 4.26352 19.0265 4.41037 19.0663C4.55723 19.106 4.71268 19.1003 4.85624 19.05L6.77577 18.3679C7.47421 18.9422 8.25468 19.3969 9.09609 19.7133L9.4664 21.7148C9.49416 21.8647 9.56688 22.0026 9.67488 22.1102C9.78289 22.2178 9.92108 22.29 10.0711 22.3172L10.1344 22.3289C11.3667 22.5504 12.6286 22.5504 13.8609 22.3289L13.9242 22.3172C14.0742 22.29 14.2124 22.2178 14.3204 22.1102C14.4284 22.0026 14.5011 21.8647 14.5289 21.7148L14.8969 19.7226C15.745 19.4047 16.5345 18.9485 17.2336 18.3726L19.1391 19.05C19.2826 19.1007 19.4381 19.1066 19.5851 19.0669C19.732 19.0271 19.8634 18.9435 19.9617 18.8273L20.0039 18.7781C20.8195 17.8148 21.4476 16.7273 21.8719 15.5461L21.893 15.4851C21.9984 15.1969 21.9117 14.8687 21.675 14.6648ZM18.4758 10.9195C18.5344 11.2734 18.5648 11.6367 18.5648 12C18.5648 12.3633 18.5344 12.7265 18.4758 13.0804L18.3211 14.0203L20.0719 15.5179C19.8065 16.1294 19.4714 16.7082 19.0734 17.2429L16.8984 16.4719L16.1625 17.0765C15.6023 17.5359 14.9789 17.8969 14.3039 18.15L13.4109 18.4851L12.9914 20.7586C12.3295 20.8336 11.6612 20.8336 10.9992 20.7586L10.5797 18.4804L9.69374 18.1406C9.02577 17.8875 8.40468 17.5265 7.84921 17.0695L7.11327 16.4625L4.92421 17.2406C4.52577 16.7039 4.19296 16.125 3.92577 15.5156L5.69531 14.0039L5.54296 13.0664C5.48671 12.7172 5.45624 12.3562 5.45624 12C5.45624 11.6414 5.48437 11.2828 5.54296 10.9336L5.69531 9.99607L3.92577 8.48435C4.19062 7.87263 4.52577 7.29607 4.92421 6.75935L7.11327 7.53748L7.84921 6.93044C8.40468 6.47341 9.02577 6.11248 9.69374 5.85935L10.582 5.52419L11.0016 3.24607C11.6601 3.17107 12.3328 3.17107 12.9937 3.24607L13.4133 5.51951L14.3062 5.85466C14.9789 6.10779 15.6047 6.46873 16.1648 6.9281L16.9008 7.53279L19.0758 6.76169C19.4742 7.29841 19.807 7.87732 20.0742 8.48669L18.3234 9.98435L18.4758 10.9195ZM12 7.6406C9.72187 7.6406 7.87499 9.48748 7.87499 11.7656C7.87499 14.0437 9.72187 15.8906 12 15.8906C14.2781 15.8906 16.125 14.0437 16.125 11.7656C16.125 9.48748 14.2781 7.6406 12 7.6406ZM13.8562 13.6219C13.6128 13.866 13.3234 14.0596 13.0049 14.1916C12.6863 14.3235 12.3448 14.3911 12 14.3906C11.2992 14.3906 10.6406 14.1164 10.1437 13.6219C9.89958 13.3784 9.70596 13.089 9.57403 12.7705C9.4421 12.4519 9.37446 12.1104 9.37499 11.7656C9.37499 11.0648 9.64921 10.4062 10.1437 9.90935C10.6406 9.41248 11.2992 9.1406 12 9.1406C12.7008 9.1406 13.3594 9.41248 13.8562 9.90935C14.1004 10.1528 14.294 10.4422 14.426 10.7607C14.5579 11.0793 14.6255 11.4208 14.625 11.7656C14.625 12.4664 14.3508 13.125 13.8562 13.6219Z" fill="#888888"/>
                </svg>
                <span>Technologies Used</span>
              </div>
              <div className={styles.infoRight}>
                {technologies.map((tech, index) => (
                  <img key={index} src={tech.icon} alt={tech.name} />
                ))}
              </div>
            </li>

            <li className={styles.infoItem}>
              <div className={styles.infoLeft}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12 20.7188C7.18594 20.7188 3.28125 16.8141 3.28125 12C3.28125 7.18594 7.18594 3.28125 12 3.28125C16.8141 3.28125 20.7188 7.18594 20.7188 12C20.7188 16.8141 16.8141 20.7188 12 20.7188Z" fill="#888888"/>
                  <path d="M16.0945 14.9672L12.7523 12.5508V6.75C12.7523 6.64687 12.668 6.5625 12.5648 6.5625H11.4375C11.3344 6.5625 11.25 6.64687 11.25 6.75V13.2047C11.25 13.2656 11.2781 13.3219 11.3273 13.357L15.2039 16.1836C15.2883 16.2445 15.4055 16.2258 15.4664 16.1437L16.1367 15.2297C16.1977 15.143 16.1789 15.0258 16.0945 14.9672Z" fill="#888888"/>
                </svg>
                <span>Timescale</span>
              </div>
              <div className={styles.infoRight}>{timescale}</div>
            </li>

            <li className={styles.infoItem}>
              <div className={styles.infoLeft}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.25 17.25C20.25 14.6344 18.7172 12.375 16.5 11.3227V7.43672C16.5 7.08281 16.3758 6.74063 16.1461 6.47109L12.5742 2.23594C12.4242 2.05781 12.2109 1.96875 12 1.96875C11.7891 1.96875 11.5758 2.05781 11.4258 2.23594L7.85391 6.47109C7.62578 6.74118 7.50043 7.08318 7.5 7.43672V11.3227C5.28281 12.375 3.75 14.6344 3.75 17.25H7.41797C7.36406 17.4187 7.33594 17.6016 7.33594 17.8078C7.33594 18.3258 7.51406 18.832 7.8375 19.2328C8.1015 19.5606 8.45115 19.8088 8.84766 19.95C9.38906 21.2156 10.6195 22.0312 12 22.0312C12.682 22.0312 13.343 21.8297 13.9078 21.45C14.4609 21.0797 14.8898 20.5617 15.15 19.95C15.5463 19.8097 15.896 19.5623 16.1602 19.2352C16.484 18.8307 16.6609 18.3283 16.6617 17.8102C16.6617 17.6133 16.6359 17.4258 16.5891 17.2523H20.25V17.25ZM17.8664 14.5641C18.0867 14.9063 18.2648 15.2742 18.3937 15.6562H16.4062V13.0945C16.991 13.4761 17.4886 13.9769 17.8664 14.5641ZM9.09375 11.3227V7.47187L12 4.02656L14.9062 7.47187V15.6562H9.09375V11.3227ZM5.60625 15.6562C5.73516 15.2742 5.91328 14.9063 6.13359 14.5641C6.51563 13.9734 7.0125 13.4742 7.59375 13.0945V15.6562H5.60625ZM14.7211 18.3797C14.5992 18.45 14.4586 18.4781 14.3203 18.4594L13.8633 18.4031L13.7977 18.8578C13.6711 19.7461 12.8977 20.4164 12 20.4164C11.1023 20.4164 10.3289 19.7461 10.2023 18.8578L10.1367 18.4008L9.67969 18.4594C9.54074 18.4759 9.40017 18.4472 9.27891 18.3773C9.075 18.2602 8.94844 18.0422 8.94844 17.8055C8.94844 17.557 9.08672 17.3508 9.29062 17.2477H14.7117C14.918 17.3531 15.0539 17.5594 15.0539 17.8055C15.0516 18.0445 14.925 18.2648 14.7211 18.3797ZM10.875 9.375C10.875 9.67337 10.9935 9.95952 11.2045 10.1705C11.4155 10.3815 11.7016 10.5 12 10.5C12.2984 10.5 12.5845 10.3815 12.7955 10.1705C13.0065 9.95952 13.125 9.67337 13.125 9.375C13.125 9.07663 13.0065 8.79048 12.7955 8.5795C12.5845 8.36853 12.2984 8.25 12 8.25C11.7016 8.25 11.4155 8.36853 11.2045 8.5795C10.9935 8.79048 10.875 9.07663 10.875 9.375Z" fill="#888888"/>
                </svg>
                <span>Launch Date</span>
              </div>
              <div className={styles.infoRight}>{launchDate}</div>
            </li>

            <li className={styles.infoItem}>
              <div className={styles.infoLeft}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.6719 6.37734V3.375C20.6719 2.96016 20.3367 2.625 19.9219 2.625H4.07814C3.6633 2.625 3.32814 2.96016 3.32814 3.375V6.37734C2.93673 6.40078 2.62501 6.72656 2.62501 7.125V10.2117C2.62351 10.779 2.73838 11.3406 2.96251 11.8617C3.0633 12.1008 3.18751 12.3258 3.32814 12.5391V20.625C3.32814 21.0375 3.6633 21.375 4.07814 21.375H19.9219C20.3367 21.375 20.6719 21.0398 20.6719 20.625V12.5391C20.8147 12.3252 20.9371 12.0985 21.0375 11.8617C21.2602 11.3391 21.375 10.7836 21.375 10.2117V7.125C21.375 6.72656 21.0633 6.40078 20.6719 6.37734ZM5.01564 4.3125H18.9844V6.375H5.01564V4.3125ZM13.5 19.6898H10.5V17.25H13.5V19.6898ZM18.9844 19.6898H15V16.5C15 16.0852 14.6649 15.75 14.25 15.75H9.75001C9.33517 15.75 9.00001 16.0852 9.00001 16.5V19.6898H5.01564V14.0133C5.08361 14.0461 5.15392 14.0789 5.22658 14.107C5.74923 14.3273 6.3047 14.4375 6.87658 14.4375C7.44845 14.4375 8.00158 14.3273 8.52658 14.107C8.85001 13.9711 9.1547 13.7977 9.43361 13.5891C9.4383 13.5867 9.44298 13.5867 9.44767 13.5891C9.72744 13.7985 10.0321 13.9725 10.3547 14.107C10.8774 14.3273 11.4328 14.4375 12.0047 14.4375C12.5766 14.4375 13.1297 14.3273 13.6547 14.107C13.9781 13.9711 14.2828 13.7977 14.5617 13.5891C14.5664 13.5867 14.5711 13.5867 14.5758 13.5891C14.8556 13.7985 15.1602 13.9725 15.4828 14.107C16.0055 14.3273 16.561 14.4375 17.1328 14.4375C17.7047 14.4375 18.2578 14.3273 18.7828 14.107C18.8531 14.0766 18.9235 14.0461 18.9938 14.0133V19.6898H18.9844ZM19.6875 10.2117C19.6875 11.6133 18.5391 12.75 17.1258 12.75C16.1695 12.75 15.3352 12.232 14.8945 11.4633C14.8266 11.3461 14.7047 11.2734 14.5688 11.2734H14.5547C14.4211 11.2734 14.2969 11.3461 14.2289 11.4633C14.0041 11.8554 13.6794 12.1811 13.2879 12.4071C12.8964 12.6331 12.4521 12.7514 12 12.75C11.0461 12.75 10.2141 12.2344 9.77345 11.468C9.70314 11.3484 9.57658 11.2734 9.4383 11.2734C9.30001 11.2734 9.17111 11.3484 9.10314 11.468C8.87697 11.8586 8.55188 12.1828 8.16059 12.4079C7.7693 12.6329 7.32563 12.7509 6.87423 12.75C5.46095 12.75 4.31251 11.6133 4.31251 10.2117V8.07422C4.31251 8.06719 4.3172 8.0625 4.32423 8.0625H19.6758C19.6828 8.0625 19.6875 8.06719 19.6875 8.07422V10.2117Z" fill="#888888"/>
                </svg>
                <span>Industry</span>
              </div>
              <div className={styles.infoRight}>{industry}</div>
            </li>
          </ul>

          {websiteUrl && (
  <div
    className={styles.visitButton}
    role="button"
    tabIndex={0}
    onClick={() => window.open(websiteUrl, "_blank")}
    onKeyDown={(e) => {
      if (e.key === "Enter") window.open(websiteUrl, "_blank");
    }}
  >
    View All
  </div>
)}


        </div>
      </div>
    

      {/* Objective Section */}
      <div className={styles.projectContainer}>
        <div className={styles.projectImage}>
          <img src={projectImage} alt={`${title} project`} />
        </div>
        <div className={styles.container1}>
        <div className={styles.objective}>Objective</div>

        <h2 className={styles.projectHeading}>
        <h3 className={styles.projectHeading}>{objective.heading}</h3>

        </h2>

        <p className={styles.projectText}>
        <div>{objective.content}</div>
        </p>
      </div>
      </div>

      {/* Process Section */}
      <div className={styles.projectContainer}>
        <div className={styles.projectImage}>
          <img src={projectImage2} alt={`${title} project`} />
        </div>
  <div className={styles.container1}>
        <div className={styles.objective}>Process</div>

        <h2 className={styles.projectHeading}>
        <h3 className={styles.projectHeading}>{process.heading}</h3>
        </h2>

        <p className={styles.projectText}>
        <div>{process.content}</div>
        </p>
      </div>
</div></div>
      {/* Impact Section */}
      <div className="">
        <div className={styles.projectImage}>
          <img src={projectImage3} alt={`${title} project`} />
        </div>   
  <div className='container'>
  <div className={styles.container1}>
        <div className={styles.objective}>Impact</div>

        <h2 className={styles.projectHeading}>
        <h3 className={styles.projectHeading}>{impact.heading}</h3>
        </h2>

        <p className={styles.projectText}>
        <div className={styles.projectText}>{impact.content}</div>
        </p>
      </div>
     
      </div>
      </div>
         <div className='container'>
  <div className={styles.container1}>
        <div className={styles.objective}>Conclusion</div>

        <h2 className={styles.projectHeading}>
        <h3 className={styles.projectHeading}>{conclusion.heading}</h3>
        </h2>

        <p className={styles.projectText}>
        <div className={styles.projectText}>{conclusion.content}</div>
        </p>
      </div>
      </div>
      <div className='container'>
    <div className={styles.caseStudiesSection}>
    <h2 className={styles.sectionTitle}>Case Studies</h2>
 
<div className={styles.caseStudiesGrid}>
  {(caseStudies || []).map((study, index) => (
    <div key={index} className={styles.caseCard}>
    <div className={styles.imageWrapper}>
  
    <img src={study.image} alt={study.title} className={styles.caseImage} />


  {/* Moved out of <a> */}
  <div className={styles.hoverOverlay}>
    <a
      href={study.link}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.link}
      onClick={e => e.stopPropagation()}
    >
      <div className={styles.icon}>
        <img src={wifi} alt="Live Website" />
        <p>Live Website</p>
      </div>
    </a>
    <a
      href={study.pagelink}
      className={styles.link}
      target="_blank"
      rel="noopener noreferrer"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
   
    >
      <div className={styles.icon}>
        <img src={case_studies} alt="Case Studies" />
        <p>Case Studies</p>
      </div>
    </a>
  </div>
</div>
 <p className={styles.category}>{study.category}</p>
         <h3 className={styles.title}>{study.title}</h3>
    </div>
  ))}
</div>

  </div>
</div>
{websiteUrl && (
  <div className={styles.visitbtn}>
    <div
      className={styles.visitButton}
      role="button"
      tabIndex={0}
      onClick={() => window.open(websiteUrl, "_blank")}
      onKeyDown={(e) => {
        if (e.key === "Enter") window.open(websiteUrl, "_blank");
      }}
    >
      View All
    </div>
  </div>
)}


    </>
  );
};

export default CaseStudy;